import ElementUI from "element-ui";
import axios from "axios";
import dayjs from "dayjs";
import httpnoauth from "./httpnoauth";
import router from "../router";
import store from "../store";

// Require Auth Requests
const httpauth = axios.create({
  baseURL: store.getters["root/apiUrl"],
  headers: {
    "Content-Type": "application/json",
  },
});

// Handle Refresh Token
httpauth.interceptors.request.use((config) => {
  const originalRequest = config;
  const now = dayjs().valueOf();
  const expiry = store.getters["user/expiry"];
  const userid = store.getters["user/userid"];

  // Token expired or about to expire
  if (expiry - 300 <= now) {
    const refreshToken = store.getters["user/refreshToken"];
    return httpnoauth.post("/nrl/api/v1/admin/authorize", {
      refresh_token: refreshToken,
      user_id: userid,
    }).then((response) => {
      store.commit("user/login", response.data);
      // Update Auth Header
      const token = store.getters["user/accessToken"];
      const authheader = `${userid}:${token}`;
      const encodedString = btoa(authheader);
      originalRequest.headers.Authorization = `Bearer ${encodedString}`;
      originalRequest.headers["active-Role"] = store.getters["user/activeRoleId"];
      return originalRequest;
    }).catch((e) => {
      store.commit("user/logout");
      router.go("/login");
      return e;
    });
    // eslint-disable-next-line no-else-return
  } else {
    // Update Auth Header
    const accessToken = store.getters["user/accessToken"];
    const authheader = `${userid}:${accessToken}`;
    const encodedString = btoa(authheader);
    originalRequest.headers.Authorization = `Bearer ${encodedString}`;
    originalRequest.headers["active-Role"] = store.getters["user/activeRoleId"];
    return originalRequest;
  }
}, err => Promise.reject(err));

// Handle Global Error Handler
httpauth.interceptors.response.use(response => response, (error) => {
  if (error && error.response) {
    const { status, data } = error.response;

    if (status === 401) {
      // Not Authorized, redirect to login
      store.commit("user/logout");
      store.commit("root/loading", false);
      router.go("/login");
    } else if (status === 403) {
      // Forbidden, show message from server
      ElementUI.Notification.error({
        title: "Permission Denied",
        message: data.message || "You do not have permission to perform this action.",
        duration: 10000
      });
      store.commit("root/loading", false);
    } else {
      // Generic Error Handler
      ElementUI.Notification.error({
        title: "Error",
        message: data.message || "There has been an error",
        duration: 10000
      });
      store.commit("root/loading", false);
    }
  }
  return Promise.reject(error);
});

export default httpauth;
